/** The list with `value` added, or removed when it was already in it. */
export const toggleInList = (list, value) => list.includes(value) ? list.filter((v) => v !== value) : [...list, value];
//# sourceMappingURL=list.js.map